import React from "react";

import useIsLoggedIn from "../../hooks/use-IsLoggedIn";
import Header from "../Profile/components/Header";
import Footer from "../StaticPages/Footer";

function Layout({ children }) {
	const isLoggedIn = useIsLoggedIn();

	return (
		<>
			<Header isLoggedIn={isLoggedIn} />

			{children}

			<div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
				<div className="rounded-3xl overflow-hidden">
					<Footer />
				</div>
			</div>
		</>
	);
}

export default Layout;
